<template>
  <div class="profile-page">
    <!-- 头部用户信息区 -->
    <div class="profile-header">
      <!-- 头像 -->
      <img :src="$store.state.LoginStorage.image" class="user-avatar" alt="avatar" />
      <!-- 信息主体 -->
      <div class="user-info">
        <div class="user-top-row">
          <h2 class="user-name">{{ $store.state.LoginStorage.nickname }}</h2>
          <span class="user-meta">ID {{ $store.state.LoginStorage.yhid }}</span>
          <span class="user-bio-tag">{{ $store.state.LoginStorage.hangye }} ✨</span>
        </div>
        <!-- 数据统计 -->
        <div class="user-stats">
          <div class="stat-item">
            <span class="stat-num">{{ $store.state.LoginStorage.zbid.length }}</span>
            <span class="stat-label">关注</span>
          </div>
          <div class="stat-divider"></div>
          <div class="stat-item">
            <span class="stat-num">0</span>
            <span class="stat-label">粉丝</span>
          </div>
          <div class="stat-divider"></div>
          <div class="stat-item">
            <span class="stat-num">{{ $store.state.LoginStorage.like.length || 0 }}</span>
            <span class="stat-label">赞</span>
          </div>
        </div>
      </div>
      <!-- 操作按钮 -->
      <div class="header-actions">
        <button class="upload-btn" @click="uploadContent">
          <i class="el-icon-upload2"></i>
          <span>上传</span>
        </button>
        <button class="edit-btn" @click="editProfile">编辑资料</button>
        <button class="share-btn" @click="shareProfile">
          <i class="el-icon-switch-button"></i>
          <span>退出</span>
        </button>
      </div>
    </div>

    <!-- 导航标签页 -->
    <div class="profile-tabs">
      <div
        v-for="(tab, index) in tabs"
        :key="index"
        class="tab-item"
        :class="{ active: activeTab === index }"
        @click="switchTab(index)"
      >
        {{ tab.name }}
      </div>
    </div>

    <!-- 内容区域 -->
    <div class="profile-content">
      <!-- 观看历史 -->
      <div v-if="activeTab === 0" class="history-section">
        <div v-if="historyList.length > 0" class="video-grid">
          <div v-for="(item, index) in historyList" :key="index" class="video-card" @click="playVideo(item)">
            <div class="video-cover" :style="{ background: item.cover }">
              <span class="video-tag" :class="item.tagType">{{ item.tag }}</span>
              <span class="video-viewers">
                <i class="el-icon-user"></i>{{ item.viewers }}
              </span>
            </div>
            <div class="video-info">
              <img :src="item.avatar" class="video-avatar" alt="avatar" />
              <span class="video-name">{{ item.name }}</span>
            </div>
          </div>
        </div>
        <div v-else class="empty-state">
          <i class="el-icon-video-play"></i>
          <p>暂无作品</p>
        </div>
      </div>

      <!-- 关注 -->
      <div v-else-if="activeTab === 1" class="favorite-section">
        <div v-if="favoriteList.length > 0">
          <!-- 横向图片 -->
          <div class="video-grid">
            <div v-for="(item, index) in landscapeList" :key="'landscape-'+index" class="video-card" @click="playVideo(item)">
              <div class="video-cover">
                <img :src="item.cover.replace('url(', '').replace(')', '')" class="cover-img" alt="cover" @load="onImageLoad($event, item)" />
                <!-- 未开播时显示黑色遮罩 -->
                <div v-if="item.statuss === 0" class="offline-overlay"></div>
                <span class="video-tag" :class="item.tagType">{{ item.tag }}</span>
                <span class="video-viewers">
                  <i class="el-icon-user"></i>{{ item.viewers }}
                </span>
              </div>
              <div class="video-info">
                <img :src="item.avatar" class="video-avatar" alt="avatar" />
                <span class="video-name">{{ item.name }}</span>
              </div>
            </div>
          </div>
          <!-- 竖向图片 -->
          <div class="video-grid portrait-grid">
            <div v-for="(item, index) in portraitList" :key="'portrait-'+index" class="video-card" @click="playVideo(item)">
              <div class="video-cover portrait">
                <img :src="item.cover.replace('url(', '').replace(')', '')" class="cover-img" alt="cover" @load="onImageLoad($event, item)" />
                <!-- 未开播时显示黑色遮罩 -->
                <div v-if="item.statuss === 0" class="offline-overlay"></div>
                <span class="video-tag" :class="item.tagType">{{ item.tag }}</span>
                <span class="video-viewers">
                  <i class="el-icon-user"></i>{{ item.viewers }}
                </span>
              </div>
              <div class="video-info">
                <img :src="item.avatar" class="video-avatar" alt="avatar" />
                <span class="video-name">{{ item.name }}</span>
              </div>
            </div>
          </div>
        </div>
        <div v-else class="empty-state">
          <i class="el-icon-star-off"></i>
          <p>暂无关注内容</p>
        </div>
      </div>

      <!-- 赞过 -->
      <div v-else-if="activeTab === 2" class="liked-section">
        <div v-if="likedList.length > 0">
          <!-- 横向图片 -->
          <div class="video-grid">
            <div v-for="(item, index) in likedLandscapeList" :key="'liked-landscape-'+index" class="video-card" @click="huifang(item.id)">
              <div class="video-cover">
                <img :src="item.cover.replace('url(', '').replace(')', '')" class="cover-img" alt="cover" @load="onImageLoad($event, item)" />
                <span class="video-tag replay">回放</span>
              </div>
              <div class="video-info">
                <img :src="item.avatar" class="video-avatar" alt="avatar" />
                <span class="video-name">{{ item.name }}</span>
              </div>
            </div>
          </div>
          <!-- 竖向图片 -->
          <div class="video-grid portrait-grid">
            <div v-for="(item, index) in likedPortraitList" :key="'liked-portrait-'+index" class="video-card" @click="huifang(item.id)">
              <div class="video-cover portrait">
                <img :src="item.cover.replace('url(', '').replace(')', '')" class="cover-img" alt="cover" @load="onImageLoad($event, item)" />
                <span class="video-tag replay">回放</span>
              </div>
              <div class="video-info">
                <img :src="item.avatar" class="video-avatar" alt="avatar" />
                <span class="video-name">{{ item.name }}</span>
              </div>
            </div>
          </div>
        </div>
        <div v-else class="empty-state">
          <i class="el-icon-thumb"></i>
          <p>暂无赞过的内容</p>
        </div>
      </div>

      <!-- 礼物 -->
      <div v-else-if="activeTab === 3" class="gift-section">
        <div v-if="giftRecords.length > 0" class="gift-list">
          <div v-for="(gift, index) in giftRecords" :key="index" class="gift-item">
            <!-- 顶部礼物图 -->
            <div class="gift-icon">
              <img :src="gift.image" alt="gift" />
            </div>
            <!-- 底部信息 -->
            <div class="gift-info">
              <span class="gift-name">{{ gift.name }}</span>
              <span class="gift-price">{{ gift.jine }} 星动/个</span>
              <span class="gift-anchor">送给：{{ gift.anchor_name }}</span>
              <span class="gift-time">房间号：{{ gift.zhuboid }}</span>
              <div class="gift-bottom">
                <span class="gift-num">x{{ 1 }}</span>
                <span class="gift-total">共 {{ gift.number }} 星动</span>
              </div>
            </div>
          </div>
        </div>
        <div v-else class="empty-state">
          <i class="el-icon-present"></i>
          <p>暂无礼物记录</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'ProfilePage',
  data() {
    return {
      // 用户信息
      // 标签页
      tabs: [
        { name: '我的作品', id: 'history' },
        { name: '关注', id: 'favorite' },
        { name: '赞过', id: 'liked' },
        // { name: '钱包', id: 'wallet' },
        { name: '礼物', id: 'gift' }
      ],
      // 当前选中标签
      activeTab: 0,
      // 我的作品 - 默认为空
      historyList: [],
      // 收藏列表
      favoriteList: [],
      // 赞过列表
      likedList: [],
      // 消费记录
      consumeRecords: [],
      // 送礼记录
      giftRecords: []
    }
  },
  computed: {
    // 关注列表 - 横向图片
    landscapeList() {
      return this.favoriteList.filter(item => !item.isPortrait)
    },
    // 关注列表 - 竖向图片
    portraitList() {
      return this.favoriteList.filter(item => item.isPortrait)
    },
    // 赞过列表 - 横向图片
    likedLandscapeList() {
      return this.likedList.filter(item => !item.isPortrait)
    },
    // 赞过列表 - 竖向图片
    likedPortraitList() {
      return this.likedList.filter(item => item.isPortrait)
    }
  },
  mounted() {
    // 请求送礼记录
    axios.get('https://guangxing.xiangyouhulian.cn/api/index/slwlist',{
      params:{
        yhid:this.$store.state.LoginStorage.id
      }
    })
      .then(response => {
        this.giftRecords = response.data.data;
        console.log('Gift records fetched:', response.data.data);
      })
      .catch(error => {
        console.error('Error fetching history:', error);
      });
    
    // 请求关注列表
    this.fetchFollowList()
    // 请求点赞列表
    this.fetchLikeList()
  },
  methods: {
    // 编辑资料
    editProfile() {
      this.$router.push('/shezhi');
    },
    // 退出登录
    shareProfile() {
      // 弹出确认框
      this.$confirm('确定要退出登录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 删除本地存储
        localStorage.removeItem('TTxq')
        // 清空 Vuex
        this.$store.commit('LoginModification', -1)
        // 跳转到首页
        this.$router.push('/')
        this.$message.success('已退出登录')
      }).catch(() => {
        // 取消退出
      })
    },
    // 上传内容
    uploadContent() {
      this.$router.push('/scsp');
    },
    // 显示菜单
    showMenu() {
      this.$emit('showMenu')
    },
    // 切换标签
    switchTab(index) {
      this.activeTab = index
    },
    // 播放视频
    playVideo(item) {
      console.log(item.anchorid,item.id)
      this.$router.push(`/zb/${item.anchorid}/${item.id}`);
    },
    huifang(id) {
      this.$router.push(`/hf/${id}/${10}`);
    },
    // 图片加载完成后判断比例
    onImageLoad(event, item) {
      const img = event.target
      const width = img.naturalWidth
      const height = img.naturalHeight
      // 如果高度大于宽度，认为是竖向图片
      this.$set(item, 'isPortrait', height > width)
    },
    // 充值 - 打开充值弹窗
    recharge() {
      this.$store.commit('setVipshow', true)
    },
    // 获取关注列表
    fetchFollowList() {
      const userId = this.$store.state.LoginStorage.id
      if (!userId) {
        console.log('用户未登录，无法获取关注列表')
        return
      }
      
      axios.get('https://guangxing.xiangyouhulian.cn/api/index/guanzhu', {
        params: {
          yhid: userId
        }
      }).then(response => {
        console.log('关注列表接口返回:', response.data)
        if (response.data.code === 1 && response.data.data) {
          // 转换数据格式适配页面展示
          this.favoriteList = response.data.data.map(item => ({
            id: item.id,
            anchorid:item.anchorid,
            name: item.anchor_name,
            avatar: item.touxiang,
            cover: `url(${item.image})`,  // 背景图需要url()包裹
            viewers: item.anchor_number,
            statuss: item.statuss,  // 保存状态用于判断
            tag: item.statuss == 1 ? '直播中' : (item.statuss == 0 ? '待开播' : '回放'),
            tagType: item.statuss == 1 ? 'live' : (item.statuss == 0 ? 'offline' : 'replay'),
            rawData: item  // 保留原始数据
          }))
        }
      }).catch(error => {
        console.error('获取关注列表失败:', error)
      })
    },
    // 获取点赞列表
    fetchLikeList() {
      const userId = this.$store.state.LoginStorage.id
      if (!userId) {
        console.log('用户未登录，无法获取点赞列表')
        return
      }
      
      axios.get('https://guangxing.xiangyouhulian.cn/api/index/likes', {
        params: {
          yhid: userId
        }
      }).then(response => {
        console.log('点赞列表接口返回:', response.data)
        if (response.data.code === 1 && response.data.data) {
          // 转换数据格式适配页面展示
          this.likedList = response.data.data.map(item => ({
            id: item.id,
            anchorid:item.anchorid,
            name: item.anchor_name,
            avatar: item.touxiang,
            cover: `url(${item.hfimage})`,  // 背景图需要url()包裹
            viewers: item.anchor_number,
            paixu: item.paixu || 1,  // 保存排序字段
            rawData: item  // 保留原始数据
          }))
        }
      }).catch(error => {
        console.error('获取点赞列表失败:', error)
      })
    }
  }
}
</script>

<style scoped lang="scss">
/* ========== 个人中心：灰底白卡 + 粉色点缀，层次用1px边框、无阴影 ========== */

// 页面主容器
.profile-page {
  min-height: 100%;
  width: 71.5%;
  margin: 0 auto;
  padding: 18px 24px 28px;
  background: #f4f4f5;
  box-sizing: border-box;
}

// ===== 头部用户信息区 =====
.profile-header {
  display: flex;
  align-items: center;
  gap: 20px;
  padding: 20px 24px;
  margin-bottom: 10px;
  background: #fff;
  border: 1px solid #e3e5e7;
  border-radius: 8px;
}

.user-avatar {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  object-fit: cover;
  border: 1px solid #e3e5e7;
  flex-shrink: 0;
}

.user-info {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.user-top-row {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

.user-name {
  font-size: 18px;
  font-weight: 600;
  color: #18191c;
  margin: 0;
}

.user-meta {
  font-size: 12px;
  color: #9499a0;
}

.user-bio-tag {
  font-size: 12px;
  color: #fb7299;
  background: #fff0f5;
  border: 1px solid #ffe4ec;
  border-radius: 4px;
  padding: 1px 8px;
}

.user-stats {
  display: flex;
  align-items: center;
  gap: 20px;
}

.stat-item {
  display: flex;
  align-items: baseline;
  gap: 4px;
}

.stat-num {
  font-size: 16px;
  font-weight: 600;
  color: #18191c;
}

.stat-label {
  font-size: 12px;
  color: #9499a0;
}

.stat-divider {
  width: 1px;
  height: 14px;
  background: #e3e5e7;
}

// 操作按钮区
.header-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
}

.upload-btn {
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 7px 16px;
  background: #f1f2f3;
  border: 1px solid #f1f2f3;
  border-radius: 6px;
  font-size: 13px;
  color: #61666d;
  cursor: pointer;
  transition: background 0.2s ease, color 0.2s ease, border-color 0.2s ease;

  &:hover {
    background: #ffe4ec;
    border-color: #ffe4ec;
    color: #fb7299;
  }

  i { font-size: 14px; }
}

.edit-btn {
  padding: 7px 20px;
  background: #fb7299;
  border: 1px solid #fb7299;
  border-radius: 6px;
  font-size: 13px;
  color: #fff;
  cursor: pointer;
  transition: background 0.2s ease, border-color 0.2s ease;

  &:hover {
    background: #ff85ad;
    border-color: #ff85ad;
  }
}

.share-btn {
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 7px 14px;
  background: #fff;
  border: 1px solid #e3e5e7;
  border-radius: 6px;
  color: #61666d;
  font-size: 13px;
  cursor: pointer;
  transition: color 0.2s ease, border-color 0.2s ease;

  &:hover {
    color: #fb7299;
    border-color: #fb7299;
  }

  i { font-size: 14px; }
}

// ===== 导航标签页 =====
.profile-tabs {
  display: flex;
  gap: 32px;
  padding: 0 20px;
  margin-bottom: 10px;
  background: #fff;
  border: 1px solid #e3e5e7;
  border-radius: 8px;
}

.tab-item {
  font-size: 14px;
  color: #61666d;
  cursor: pointer;
  padding: 12px 2px;
  position: relative;
  transition: color 0.2s ease;

  &:hover { color: #fb7299; }

  &.active {
    color: #fb7299;
    font-weight: 600;

    &::after {
      content: '';
      position: absolute;
      bottom: -1px;
      left: 0;
      right: 0;
      height: 3px;
      background: #fb7299;
      border-radius: 3px 3px 0 0;
    }
  }
}

// ===== 内容区域 =====
.profile-content {
  background: #fff;
  border: 1px solid #e3e5e7;
  border-radius: 8px;
  padding: 20px;
  min-height: 360px;
}

// 视频网格
.video-grid {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 14px;
  margin-bottom: 20px;

  &:last-child { margin-bottom: 0; }
}

.video-card { cursor: pointer; }

.video-cover {
  position: relative;
  width: 100%;
  aspect-ratio: 16 / 10;
  border-radius: 6px;
  overflow: hidden;
  background: #f1f2f3;
  border: 1px solid #e3e5e7;

  &.portrait { aspect-ratio: 3 / 4; }

  .cover-img {
    position: absolute;
    top: 0; left: 0;
    width: 100%; height: 100%;
    object-fit: cover;
    z-index: 1;
  }
}

.offline-overlay {
  position: absolute;
  top: 0; left: 0; right: 0; bottom: 0;
  background: rgba(0, 0, 0, 0.4);
  z-index: 2;
}

.video-tag {
  position: absolute;
  top: 6px; left: 6px;
  padding: 1px 7px;
  border-radius: 3px;
  font-size: 11px;
  line-height: 1.6;
  color: #fff;
  z-index: 3;

  &.live { background: #fb7299; }
  &.replay { background: #9499a0; }
  &.offline { background: #f5a623; }
}

.video-viewers {
  position: absolute;
  top: 6px; right: 6px;
  display: flex;
  align-items: center;
  gap: 3px;
  font-size: 11px;
  color: #fff;
  background: rgba(0, 0, 0, 0.55);
  padding: 1px 7px;
  border-radius: 3px;
  z-index: 3;
}

.video-info {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-top: 6px;
}

.video-avatar {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  border: 1px solid #e3e5e7;
  flex-shrink: 0;
}

.video-name {
  font-size: 12px;
  color: #18191c;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  transition: color 0.2s ease;
}

.video-card:hover .video-name { color: #fb7299; }

// 空状态
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 240px;
  color: #9499a0;

  i {
    font-size: 44px;
    margin-bottom: 14px;
    color: #c9ccd2;
  }

  p { font-size: 13px; }
}

// ===== 礼物区域 =====
.gift-section {
  .gift-list {
    display: grid;
    grid-template-columns: repeat(7, 1fr);
    gap: 10px;
  }

  .gift-item {
    display: flex;
    flex-direction: column;
    background: #fff;
    border: 1px solid #e3e5e7;
    border-radius: 6px;
    overflow: hidden;
  }

  .gift-icon {
    width: 100%;
    aspect-ratio: 1 / 1;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #fafafa;
    padding: 6px;

    img { max-width: 100%; max-height: 100%; object-fit: contain; }
  }

  .gift-info {
    display: flex;
    flex-direction: column;
    gap: 1px;
    padding: 6px 8px 8px;
  }

  .gift-name { font-size: 12px; font-weight: 600; color: #18191c; overflow: hidden; white-space: nowrap; text-overflow: ellipsis; }
  .gift-price { font-size: 10px; color: #fb7299; font-weight: 500; }
  .gift-anchor { font-size: 10px; color: #61666d; overflow: hidden; white-space: nowrap; text-overflow: ellipsis; }
  .gift-time { font-size: 9px; color: #9499a0; }

  .gift-bottom {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 2px;
    padding-top: 4px;
    border-top: 1px solid #f0f0f0;
  }

  .gift-num { font-size: 11px; font-weight: 600; color: #fb7299; }
  .gift-total { font-size: 9px; color: #9499a0; }
}
</style>